<template>
  <div class="h_container">
    <div class="left_section">
      <div class="text" v-text="workflow.name" />
    </div>
    <div class="middle_section">
      <BaseProgressLinear
        :value="progressBarValue"
        class="mt-1"
        striped
        height="6"
      />
      <div
        class="text"
        v-text="
          `${workflow.foldersCount} ${$tc(
            'organization.folder',
            folderLength
          )} `
        "
      />
    </div>
    <div class="right_section">
      <BaseButton
        icon="$mdiFolderDownload"
        type="primary"
        :loading="exportingFolders"
        @click.stop="exportWorkflowFolders()"
      >
        {{ $t("utils.export_folders") }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import Oauth from "@/core/Models/Oauth";
import { mapGetters } from "vuex";
export default {
  name: "StatisticsPanel",
  props: {
    workflow: {
      type: Object,
      default: () => {},
    },
    foldersTotal: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      exportingFolders: false,
    };
  },
  computed: {
    ...mapGetters({ folders: "folder/getAllOrganizationFolders" }),

    progressBarValue() {
      if (!this.folders.length) return 0;
      // calcul progressBar by folders total number
      return +(this.workflow.foldersCount * 100) / this.foldersTotal;
    },
    folderLength() {
      if (this.workflow.foldersCount <= 1) return 1;
      return 2;
    },
  },
  methods: {
    async exportWorkflowFolders() {
      this.exportingFolders = true;
      try {
        const oauth = Oauth.localStorage;
        const myHeaders = new Headers({
          Authorization: `Bearer ${oauth.accessToken}`,
        });
        const myInit = {
          method: "POST",
          headers: myHeaders,
        };

        const response = await fetch(
          `/api/web/organization/${this.$route.params.organizationId}/workflow/${this.workflow.id}/export/folder/`,
          myInit
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        saveAs(await response.blob(), `${this.workflow.name}.csv`);
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.exportingFolders = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.h_container {
  display: flex;
  align-items: center;
  gap: 8px;
  .left_section {
    flex: none;
    width: 200px;
  }
  .middle_section {
    width: calc(100% - 416px);
    display: flex;
    align-items: center;
    gap: 8px;
    .text {
      width: 150px;
    }
  }
  .right_section {
    flex: none;
    width: 200px;
  }
}
</style>
